export class GamingStorage {
  static getAccessToken = () => {
    return localStorage.getItem("access_token");
  };

  static setAccessToken = (token: string) => {
    localStorage.setItem("access_token", token);
  };

  static getRankUp = () => {
    return localStorage.getItem("rankByTime");
  };

  static setRankUp = (token: string) => {
    localStorage.setItem("rankByTime", token);
  };

  static setShareToMethod = (method: string) => {
    return localStorage.setItem("shareTo", method);
  };

  static getShareToMethod = () => {
    return localStorage.getItem("shareTo");
  };

  static setFeedId = (feedId: string) => {
    localStorage.setItem("feedId", feedId);
  };

  static getFeedId = () => {
    return localStorage.getItem("feedId");
  };

  static removeFeedId = () => {
    localStorage.removeItem("feedId");
  };
}
